'use client'

import { useEffect } from 'react'
import Image from 'next/image'
import { SignUpModal } from '@/components/auth/SignUpModal'
import { startDevLogin } from '@/lib/devLogin'

let pendingDevLogin: Promise<boolean> | null = null

function startEnterpriseDevLogin(returnPath: string) {
  pendingDevLogin ??= startDevLogin(returnPath).finally(() => {
    pendingDevLogin = null
  })
  return pendingDevLogin
}

export function EnterpriseLoginPage({ returnPath }: { returnPath: string }) {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_DEV_AUTO_LOGIN !== '1') return
    // With DEV_AUTO_LOGIN=1 this leaves for the local Test User magic link.
    // Disabled or failed shortcuts are a no-op, leaving normal Enterprise SSO.
    void startEnterpriseDevLogin(returnPath)
  }, [returnPath])

  return (
    <div
      data-testid="enterprise-login-page"
      className="relative flex min-h-svh w-full overflow-hidden bg-background text-foreground"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,hsl(var(--secondary)/0.35),transparent_42%)]"
      />

      <header className="absolute start-6 top-6 z-[121] flex items-center gap-3 md:start-8 md:top-8">
        {/* eslint-disable-next-line i18next/no-literal-string -- brand */}
        <Image src="/whitemartini.svg" alt="Martini" width={28} height={26} priority />
        <div className="flex items-center gap-2 text-sm font-medium tracking-tight">
          {/* eslint-disable-next-line i18next/no-literal-string -- brand */}
          <span>Martini</span>
          <span className="h-4 w-px bg-border" aria-hidden="true" />
          <span className="text-muted-foreground">Enterprise</span>
        </div>
      </header>

      <SignUpModal isOpen onClose={() => {}} defaultMode="signin" returnPath={returnPath} variant="enterprise" />
    </div>
  )
}
